import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "textToHtml",
  standalone: false
})
export class TextToHtmlPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\n/gi, "<br/>");
  }
}
